import { Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import { ConstantService } from "app/Shared/Services/constant-service";
import { EventTreeService } from "./event-tree.service";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatChipsModule } from "@angular/material/chips";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DialogModule } from "primeng/dialog";
import { TableModule } from "primeng/table";
import { EventTreeComponent } from "./event-tree.componenet";
import { TreeTableModule } from "primeng/treetable";

@Component({
    selector: 'app-event-tree-dialog',
    imports: [CommonModule, ButtonModule, MatTooltipModule, TableModule, MatExpansionModule,
        MatChipsModule, MatProgressSpinnerModule, MatChipsModule,
        MatExpansionModule,
        ConfirmDialogModule, FormsModule,
        DialogModule, EventTreeComponent, TreeTableModule
    ],
    template: `
          <p-dialog 
          header="Parent/Child Event Tree"
          id="parent-child-event-tree" 
          height="500px"
          [(visible)]="isOpenClose" 
          [modal]="false" 
          [maximizable]="true"
          [baseZIndex]="10000"
          [modal]="true" 
          draggable="true" 
          (onHide)="closeDialogbox();this.eventTreeService.isDialogOpen=false" 
          [style]="{ width: '100%' , fontSize: '17.5px !important'}"
          [breakpoints]="{ '1199px': '75%' }"
          appendTo="body"
          styleClass="event-tree-dialog"
          [focusOnShow]="false">
          <div class="col-md-12 nopadding treeContainer">
            <app-event-tree 
                [SelectedRow]="selectedRow" [pageName]="pageName">
            </app-event-tree>
          </div>

          <ng-template #footer>
            <button type="button" id="parent-child-event-tree-close"
            style="background: #e54a23 !important; border:none !important;" pButton icon="fa fa-close" (click)="closeDialogbox();this.eventTreeService.isDialogOpen=false" label="Close" 
                class="ui-button-secondary userActionBtn close-button"></button>
          </ng-template>

          </p-dialog>
`,
    styles: [`
  .treeContainer {
                max-width: 100% !important;
                min-height: 350px !important;
                z-index: 1006 !important;
                opacity: 1 !important;
                }
  .close-button {
                  padding: 2.75px 11px 2.75px 11px;
                  font-family: "Roboto", "Trebuchet MS", Arial, Helvetica, sans-serif;
                  font-size: 11px !important;
                  font-weight: lighter !important;
                }        
  ::ng-deep .event-tree-dialog .p-dialog-header .p-dialog-title {
                  font-size: 17.5px !important;
                  font-weight: 500 !important;
                  font-family: "Arial", serif !important; 
                  color: #1b1d1f;
                }                        
      `]
})
export class EventTreeDialogComponent implements OnInit {
  @Input('SelectedRow') selectedRow: any = [];
  @Input('pageName') pageName!: string;
  @Input('isTreeOpen') isOpenClose: boolean = false;
  @Output() closeDialog: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public constantService: ConstantService,
    public eventTreeService:EventTreeService) {  
  }
  closeDialogbox() {
    this.eventTreeService.isDialogOpen=false;
    this.isOpenClose=false;
    this.selectedRow=[];
    this.closeDialog.emit(false);
  }
  ngOnInit() {
  }
}